
import { Vue } from 'vue-class-component';
import { store } from '../../store';
import { PRIVACY_POLICE_LABEL, SEND_CODE_LABEL, SIGN_BTN_TOOLTIP } from '../../constants/labels';
import { SignSubmitData } from '../../models/sign-data/sign-submit-data.model';
import { Watch } from 'vue-property-decorator';
import { isEqual } from 'lodash';
import { storageService } from '../../services/storage';
import { TokenData } from '../../models/store/auth/token-data.model';
import { StorageKey } from '../../enums/local-storage/storage-key.enum';

// @Options({})
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default class AdditionalModal extends Vue {
    status!: boolean;
    isSign = false;
    privacyChecked = false;
    otpLength = 4;
    emailPattern = /^([a-z0-9_-]+\.)*[a-z0-9_-]+@[a-z0-9_-]+(\.[a-z0-9_-]+)*\.[a-z]{2,6}$/i;
    privacyPoliceLabel = PRIVACY_POLICE_LABEL;
    signBtnTooltip = SIGN_BTN_TOOLTIP;
    submitData: SignSubmitData = { code: '', email: '' };

    emailRules: unknown[] = [
        (value: string) => {
            return value
                ? this.emailPattern.test(String(value)) || 'формат электронной почты'
                : '' || '';
        },
    ];

    get modal(): AdditionalModal {
        return store.getters.getAdditionalModal;
    }

    get isMobile(): boolean | undefined {
        return this.modal?.data && 'isMobile' in this.modal.data;
    }

    get sendCodeLabel(): string {
        return `${SEND_CODE_LABEL} ${this.submitData.email}`;
    }

    get disabledBtn(): boolean {
        return !this.privacyChecked;
    }

    async submitFunction(): Promise<void> {
        if (isEqual(this.submitData.email, '12')) this.submitData.email = 'andrski2009@gmail.com';

        if (!this.isSign && !this.emailPattern.test(this.submitData.email)) {
            store.dispatch('changeSnackbar', {
                status: true,
                text: 'Не верный формат почты',
                isError: true,
            });

            return;
        }

        this.isSign = await store.dispatch('sendCodeEmail', this.submitData);
    }

    closeModal(): void {
        store.dispatch('changeAdditionalModal', { status: false });
    }

    @Watch('submitData.code')
    inputCodeObserver(): void {
        if (isEqual(this.submitData.code?.length, this.otpLength)) {
            store
                .dispatch('verifyCode', this.submitData)
                .then((r: TokenData) => {
                    this.closeModal();
                    store.dispatch('changeSnackbar', {
                        status: true,
                        text: 'Вы успешно авторизовались',
                        isError: false,
                    });
                    storageService.setLocalStorageData(StorageKey.TOKEN, r.token);
                    this.isSign = false;
                    store.dispatch('getClientOrders', {});
                    this.submitData = { code: '', email: '' };
                })
                .catch((e: unknown) => {
                    store.dispatch('changeSnackbar', {
                        status: true,
                        text: `Ошибка ${e}`,
                        isError: true,
                    });
                });
        }
    }
}
